export const LOADING_DESCRIPTOR_VALIDATION = "LOADING_DESCRIPTOR_VALIDATION";
export const DESCRIPTOR_VALIDATION = "DESCRIPTOR_VALIDATION";